import { render } from "./GooglePayButton.vue?vue&type=template&id=7c53fe2a&ts=true"
import script from "./GooglePayButton.vue?vue&type=script&lang=ts"
export * from "./GooglePayButton.vue?vue&type=script&lang=ts"

import "./GooglePayButton.vue?vue&type=style&index=0&id=7c53fe2a&lang=scss"

import exportComponent from "/github/workspace/customer/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__